import { toast } from 'react-toastify';
import AuthService from '../../services/AuthService';
import { clearAuth, setUserData } from '../../utils/AuthConfig';
import { fetchCsrfCookie } from '../../services/HttpService';
import AuthTypes from '../types/AuthTypes';

function login(postData, setErrors, submitting) {
  return async (dispatch) => {
    dispatch({ type: AuthTypes.LOGIN_REQUEST });
    try {
      await fetchCsrfCookie();
      const res = await AuthService.login(postData);
      dispatch({ type: AuthTypes.LOGIN_SUCCESS, payload: res.data });
      if (res.data?.data?.user) {
        setUserData(res.data.data.user);
      }
      if (res.data?.message) {
        toast.success(res.data.message);
      }
      submitting(false);
    } catch (error) {
      submitting(false);
      if (error?.response) {
        dispatch({ type: AuthTypes.LOGIN_ERROR, error: error.response });
        if (error.response.status === 401 && error.response.data?.message) {
          toast.error(error.response.data.message);
        } else if (error.response.status === 422 && error.response.data?.errors) {
          toast.error(error.response.data.message);
          setErrors(error.response.data.errors);
        }
      }
    }
  };
}

function forgetPassword(postData, setErrors, submitting, navigate) {
  return async (dispatch) => {
    dispatch({ type: AuthTypes.FORGOT_PASSWORD_REQUEST });
    try {
      const res = await AuthService.forgetPassword(postData);
      dispatch({ type: AuthTypes.FORGOT_PASSWORD_SUCCESS, payload: res.data });
      if (res.data) {
        if (res.data.message) {
          toast.success(res.data.message);
        }
      }
      submitting(false);
      navigate('/');
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: AuthTypes.FORGOT_PASSWORD_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        } else if (error.response.status === 404) {
          if (error.response.data && error.response.data.message) {
            toast.error(error.response.data.message);
          }
        }
      }
    }
  };
}

//* Check the reset password mail link valid or not
function getResetPassword(code, key) {
  return async (dispatch) => {
    dispatch({ type: AuthTypes.GET_RESET_PASSWORD_REQUEST });
    try {
      const res = await AuthService.getResetPassword(code, key);
      if (res && res.data)
        dispatch({
          type: AuthTypes.GET_RESET_PASSWORD_SUCCESS,
          payload: res.data
        });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: AuthTypes.GET_RESET_PASSWORD_ERROR,
          error: error.response
        });
      }
    }
  };
}

function resetPassword(postData, setErrors, submitting, navigate) {
  return async (dispatch) => {
    dispatch({ type: AuthTypes.RESET_PASSWORD_REQUEST });
    try {
      const res = await AuthService.resetPassword(postData);
      dispatch({ type: AuthTypes.RESET_PASSWORD_SUCCESS, payload: res.data });
      if (res.data) {
        if (res.data.message) {
          toast.success(res.data.message);
        }
      }
      submitting(false);
      navigate('/');
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: AuthTypes.RESET_PASSWORD_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

//* Check the reset password mail link valid or not
function getSetPassword(code, key) {
  return async (dispatch) => {
    dispatch({ type: AuthTypes.GET_SET_PASSWORD_REQUEST });
    try {
      const res = await AuthService.getSetPassword(code, key);
      if (res && res.data)
        dispatch({
          type: AuthTypes.GET_SET_PASSWORD_SUCCESS,
          payload: res.data
        });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: AuthTypes.GET_SET_PASSWORD_ERROR,
          error: error.response
        });
      }
    }
  };
}

function setPassword(postData, setErrors, submitting, navigate) {
  return async (dispatch) => {
    dispatch({ type: AuthTypes.SET_PASSWORD_REQUEST });
    try {
      const res = await AuthService.setPassword(postData);
      dispatch({ type: AuthTypes.SET_PASSWORD_SUCCESS, payload: res.data });
      if (res.data) {
        if (res.data.message) {
          toast.success(res.data.message);
        }
      }
      submitting(false);
      navigate('/');
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: AuthTypes.SET_PASSWORD_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function logout(navigate) {
  return async (dispatch) => {
    dispatch({ type: AuthTypes.LOGOUT_REQUEST });
    try {
      const res = await AuthService.logout();
      dispatch({ type: AuthTypes.LOGOUT_SUCCESS, payload: res.data });
      if (res.data?.message) {
        toast.success(res.data.message);
      }
    } catch (error) {
      if (error?.response) {
        dispatch({ type: AuthTypes.LOGOUT_ERROR, error });
      }
    } finally {
      clearAuth();
      navigate('/', { replace: true });
    }
  };
}

const AuthAction = {
  login,
  logout,
  forgetPassword,
  getResetPassword,
  resetPassword,
  getSetPassword,
  setPassword
};

export default AuthAction;
